!function() {
  class t extends HTMLElement {
    connectedCallback() {
      if (this.button = this.querySelector("[data-style-with]"), !this.button) return;
      this.button.disabled = !0;
      document.querySelector("[data-style-it-with-anchor] [data-loaded]") ? this._activate() : (this._onLoaded = this._onRecommendationsLoaded.bind(this), 
      document.addEventListener("recommendations:loaded", this._onLoaded));
    }
    disconnectedCallback() {
      document.removeEventListener("recommendations:loaded", this._onLoaded);
    }
    _onRecommendationsLoaded(t) {
      t.detail.element.closest("[data-style-it-with-anchor]") && (document.removeEventListener("recommendations:loaded", this._onLoaded), 
      this._activate());
    }
    _activate() {
      this.button.disabled = !1, this.button.classList.remove("opacity-0"), this.button.classList.add("opacity-100"), 
      this.button.addEventListener("click", this._scrollToSection.bind(this), {
        once: !0
      });
    }
    _scrollToSection() {
      const t = document.querySelector("[data-style-it-with-anchor]");
      t && t.scrollIntoView({
        behavior: "smooth"
      });
    }
  }
  customElements.get("style-with-button") || customElements.define("style-with-button", t);
}();